import script from "./KeysLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeysLayout.vue?vue&type=script&setup=true&lang=ts"

import "./KeysLayout.vue?vue&type=style&index=0&id=5bb6576d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb6576d"]])

export default __exports__